import { Button } from 'antd';
import styled from 'styled-components';

export const TableContainer = styled.div`
  position: relative;
  padding-top: 10px;
  overflow: scroll;
  width: 100%;
  z-index: 1;
`;

export const StyledButton = styled(Button)`
  padding: 0;
  margin-right: 10px;
`;

export const SearchWrapper = styled.div`
  padding: 8;
  width: 300px;
`;

export const EmailTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  .debounce-search {
    top: -4px;
    right: 2%;
  }
`;
